import React, { useState, useEffect, useCallback, useMemo, useRef, useContext } from 'react';
import { ReactFlow, Handle, Position, BezierEdge, SmoothStepEdge, StepEdge, useEdges } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import RiskOverviewClimateIcon from '/src/Components/RiskOverviewClimateIcon/RiskOverviewClimateIcon';
import greenDot from '/src/assets/Green-Dot-4.svg';
import AddressSearch from '/src/Components/AddressSearch/AddressSearch';
import { WindowSizeContext } from '/src/App';
import './style.css';





const DynamicWhatWeDo = ({
    currentSection,
    sections
}) => {
    const { width, height, deviceType } = useContext(WindowSizeContext);

    const quollAnimalLogo = "https://d2dhzsfgxco53w.cloudfront.net/quoll-logo-business-green-animal-only.png";
    
    const imageFilename = "quoll-product-general-sample.webp";
    const productImageUrl = CreateCloudfrontUrl(imageFilename);

    const climateRisks = [
        {
            "id": "4",
            "risk_name": "Wildfire",
            "risk_level": "High",
            "icon_black": "Wildfire-Black.png",
            "icon_white": "Wildfire-White.png",
            "is_node": true,
            "node_type_id": "risk",
            "node_type": "riskNode"
        },
        {
            "id": "3",
            "risk_name": "Drought",
            "risk_level": "High",
            "icon_black": "Drought-Black.png",
            "icon_white": "Drought-White.png",
            "is_node": true,
            "node_type_id": "risk",
            "node_type": "riskNode"
        },
        {
            "id": "14",
            "risk_name": "Wind",
            "risk_level": "Medium",
            "icon_black": "Wind-Black.png",
            "icon_white": "Wind-White.png",
            "is_node": true,
            "node_type_id": "risk",
            "node_type": "riskNode"
        },
        {
            "id": "6",
            "risk_name": "Hail",
            "risk_level": "Medium",
            "icon_black": "Hail-Black.png",
            "icon_white": "Hail-White.png",
            "is_node": true,
            "node_type_id": "risk",
            "node_type": "riskNode"
        },
        {
            "id": "2",
            "risk_name": "Severe Storm",
            "risk_level": "Medium",
            "icon_black": "Convection-Black.png",
            "icon_white": "Convection-White.png",
            "is_node": true,
            "node_type_id": "risk",
            "node_type": "riskNode"
        },
    ]

    const projectsList = [
        {
            "id": "45",
            "project_image": "shingles.jpg",
            "project_name": "Install Non-Combustible Roofing",
            "is_node": true,
            "node_type_id": "project",
            "node_type": "projectNode"
        },
        {
            "id": "18",
            "project_image": "window-installation.jpg",
            "project_name": "Install Wind-Rated Windows",
            "is_node": true,
            "node_type_id": "project",
            "node_type": "projectNode"
        },
        {
            "id": "37",
            "project_image": "siding.jpg",
            "project_name": "Install Fiber-Cement Siding",
            "is_node": true,
            "node_type_id": "project",
            "node_type": "projectNode"
        }
    ]

    const homeAreasThreatened = [
        {
            "id": "2",
            "category": "Roof",
            "icon": "Roof-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "1",
            "category": "Landscaping",
            "icon": "Landscaping-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "6",
            "category": "Windows",
            "icon": "Window-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "4",
            "category": "Foundation",
            "icon": "House-Foundation-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "9",
            "category": "Siding",
            "icon": "Siding-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "10",
            "category": "HVAC",
            "icon": "HVAC-Black.png",
            "risk_level_adjusted": "medium",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "7",
            "category": "Doors",
            "icon": "Door-Black.png",
            "risk_level_adjusted": "medium",
            "is_node": true,
            "node_type": "area"
        },
        {
            "id": "5",
            "category": "Plumbing",
            "icon": "Plumbing-Black.png",
            "risk_level_adjusted": "low",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "14",
            "category": "Frame / Structure",
            "icon": "House-Frame-Black.png",
            "risk_level_adjusted": "high",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        },
        {
            "id": "13",
            "category": "Basement",
            "icon": "Basement-Black.png",
            "risk_level_adjusted": "low",
            "is_node": true,
            "node_type_id": "area",
            "node_type": "houseMarkerNode"
        }
    ]



    const edgeRed = 'var(--related_red)';
    const edgeYellow = 'var(--yellow)';
    const edgeGrey = 'var(--grey)';

    const edgeConnections = [
        {
            stage: 1,
            connections: [
                {
                    source: "risk-4",
                    target: "area-1",
                    color: edgeRed
                },
                {
                    source: "risk-4",
                    target: "area-2",
                    color: edgeRed
                },
                {
                    source: "risk-4",
                    target: "area-9",
                    color: edgeRed
                },
                {
                    source: "risk-4",
                    target: "area-14",
                    color: edgeRed
                }
            ]
        },
        {
            stage: 2,
            connections: [
                {
                    source: "risk-4",
                    target: "house-diagram",
                    color: edgeRed
                },
                {
                    source: "risk-3",
                    target: "house-diagram",
                    color: edgeRed
                },
                {
                    source: "risk-14",
                    target: "house-diagram",
                    color: edgeYellow
                },
                {
                    source: "risk-6",
                    target: "house-diagram",
                    color: edgeYellow
                },
                {
                    source: "risk-2",
                    target: "house-diagram",
                    color: edgeYellow
                },
                {
                    source: "house-diagram",
                    target: "supplemental-info-container",
                    color: edgeGrey
                }
            ]
        },
        {
            stage: 3,
            connections: [
                {
                    source: "risk-4",
                    target: "area-9",
                    color: edgeRed
                },
                {
                    source: "risk-4",
                    target: "area-2",
                    color: edgeRed
                },
                {
                    source: "risk-6",
                    target: "area-9",
                    color: edgeYellow
                },
                {
                    source: "risk-14",
                    target: "area-6",
                    color: edgeYellow
                },
                {
                    source: "project-18",
                    target: "supplemental-info-container",
                    color: edgeGrey
                }
            ]
        },
        {
            stage: 4,
            connections: [
                {
                    source: "project-18",
                    target: "supplemental-info-container",
                    color: edgeGrey
                },
                {
                    source: "project-37",
                    target: "supplemental-info-container",
                    color: edgeGrey
                },
                {
                    source: "project-45",
                    target: "supplemental-info-container",
                    color: edgeGrey
                }
            ]
        }
    ]

    const [houseAreasThreatened, setHouseAreasThreatened] = useState([]);
    const [filteredHouseAreasThreatened, setFilteredHouseAreasThreatened] = useState(homeAreasThreatened);
    const [filteredClimateRisks, setFilteredClimateRisks] = useState(climateRisks);
    const [supplementalItem, setSupplementalItem] = useState({});
    const [supplementalInfo, setSupplementalInfo] = useState([]);
    const [showFlow, setShowFlow] = useState(false);
    const [flowReady, setFlowReady] = useState(false);
    const [nodes, setNodes] = useState([]);
    const [edges, setEdges] = useState([]);
    const [showLiveSearchBar, setShowLiveSearchBar] = useState(false);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const hasRunRef = useRef(false);

    const nodeTypes = useMemo(() => ({
        riskNode: RiskNode,
        projectNode: ProjectNode,
        houseMarkerNode: HouseMarkerNode,
        supplementalInfoContainerNode: SupplementalInfoContainerNode,
        supplementalInfoItemNode: SupplementalInfoItemNode,
        houseImageNode: HouseImageNode
    }), []);

    const nodeTypeOffesets = {
        riskNode: 30,
        projectNode: 0,
        houseMarkerNode: 0,
        supplementalInfoContainerNode: 0,
        supplementalInfoItemNode: 0,
        houseImageNode: 0
    }

    const edgeTypes = useMemo(() => ({
        smoothstep: SmoothStepEdge,
        bezier: BezierEdge
    }), []);

    // Function to get element position relative to the container
    const getElementPosition = useCallback((element) => {
        const container = document.querySelector('.dynamic-what-we-do-container');
        if (!element || !container) return { x: 0, y: 0 };

        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        return {
            x: elementRect.left - containerRect.left + (elementRect.width / 2),
            y: elementRect.top - containerRect.top + (elementRect.height / 2)
        };
    }, []);

    // Replace only this specific useEffect
    useEffect(() => {
        if (showFlow && currentSection !== 0) {
            setFlowReady(false);
            const timer = setTimeout(() => {
                const { nodes, edges } = getNodesAndEdges();
                if (nodes.length > 0) {
                    setNodes(nodes);
                    // console.log('Nodes created:', nodes);
                }
                if (edges.length > 0) {
                    setEdges(edges);
                    // console.log('Edges created:', edges);
                }
                setFlowReady(true);
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [showFlow, currentSection, width, height]);

    const getNodesAndEdges = () => {

        // Combine risks, projects, house areas into single array
        const allItems = [...climateRisks, ...projectsList, ...homeAreasThreatened];

        //    Create place for storing each node
        const nodes = [];

        // Map through all items
        allItems.forEach(item => {
            // Check to see if is_node is true
            if (item.is_node) {
                // console.log('ITEM', item);
                // Get the item id, node type and node type id
                const itemId = item.id;
                const nodeTypeId = item.node_type_id;
                const nodeType = item.node_type;

                const newNodeId = `${nodeTypeId}-${itemId}`;

                // Get the element
                const element = document.getElementById(newNodeId);

                // If the element exists, get the position and create a new node
                if (element) {
                    const position = getElementPosition(element);

                    // Get the offset for the node type
                    const offset = nodeTypeOffesets[nodeType];
                    position.y -= offset;

                    // Create a new node
                    const node = {
                        id: newNodeId,
                        type: nodeType,
                        position: position,
                        visible: true,
                        hidden: false,
                    }

                    // Add the node to the nodes array
                    nodes.push(node);
                } else {
                    // console.log('ELEMENT NOT FOUND', newNodeId);
                }
            }
        })

        // If there are nodes then add nodes for the house diagram and the supplemental info container
        if (nodes.length > 0) {

            // Get the house diagram element
            const houseDiagramElement = document.getElementById('house-diagram');

            // If the house diagram element exists, get the position and create a new node
            if (houseDiagramElement) {
                const position = getElementPosition(houseDiagramElement);

                // Create a new node
                const node = {
                    id: 'house-diagram',
                    type: 'houseImageNode',
                    position: position,
                    visible: true,
                    hidden: false,
                    markerEnd: undefined,
                    markerStart: undefined

                }

                nodes.push(node);
            }

            // Get the supplemental info container element
            const supplementalInfoContainerElement = document.getElementById('supplemental-info-container');

            // If the supplemental info container element exists, get the position and create a new node
            if (supplementalInfoContainerElement) {
                const position = getElementPosition(supplementalInfoContainerElement);

                // Create a new node
                const node = {
                    id: 'supplemental-info-container',
                    type: 'supplementalInfoContainerNode',
                    position: position,
                    visible: true,
                    hidden: false,
                }

                nodes.push(node);
            }
        }


        // Edges
        const edges = [];

        // Find the object in the edges array that has the same stage as the currentSection
        const edgeConnectionsObject = edgeConnections.find(edge => edge.stage === currentSection);

        // Map through the connections
        edgeConnectionsObject.connections.forEach(connection => {

            // Get the source and target 
            const source = connection.source;
            const target = connection.target;
            const color = connection.color;
            // Check to see if both elements exist
            const sourceElement = document.getElementById(source);
            const targetElement = document.getElementById(target);

            // If both elements exist, create an edge
            if (sourceElement && targetElement) {
                edges.push({
                    id: `edge-${source}-${target}`,
                    source: source,
                    target: target,
                    type: 'bezier',
                    pathOptions: {
                        offset: 1
                    },
                    animated: true,
                    style: {
                        stroke: color,
                        strokeWidth: 2,
                        strokeLinecap: 'round',
                        animation: "dashdraw 0.5s linear infinite", // Adjust the duration here
                        strokeDasharray: 5,
                        zIndex: -1
                    }
                });
            }
        })


        // Return the nodes array
        return { nodes, edges };
    }

    // useEffect to filter the house areas threatened and climate risks based on the currentSection
    useEffect(() => {

        // Use the currentSection to filter the sections prop and get the details
        const filteredSections = sections.find(section => section.stage === currentSection) || {};
        const details = filteredSections.details || [];
        setSupplementalInfo(details);
        setSupplementalItem(filteredSections)


        // SET THE DATA
        if (currentSection === 1) {
            // Set risks and filtered house areas back to original
            setFilteredHouseAreasThreatened(homeAreasThreatened);
            setFilteredClimateRisks(climateRisks);
        } else if (currentSection === 2) {
            setFilteredHouseAreasThreatened(homeAreasThreatened);
            setFilteredClimateRisks(climateRisks);
        } else if (currentSection === 3) {
            // IDs of climate risks to keep
            const climateRisksToKeep = ["4", "14", "6"];
            const houseAreasToKeep = ["2", "9", "6"];
            setFilteredHouseAreasThreatened(homeAreasThreatened.filter(area => houseAreasToKeep.includes(area.id)));
            setFilteredClimateRisks(climateRisks.filter(risk => climateRisksToKeep.includes(risk.id)));
        } else if (currentSection === 4) {
            setFilteredHouseAreasThreatened(homeAreasThreatened);
            setFilteredClimateRisks(climateRisks);
        }
    }, [currentSection]);

    // Modified handler to manage the transition
    useEffect(() => {
        // Only trigger when currentSection is 0 and the search bar isn't already showing
        if (currentSection === 0 && !showLiveSearchBar && !isTransitioning) {
            // console.log('Starting search bar transition');
            const timer = setTimeout(() => {
                setIsTransitioning(true);
                // Add a small delay before showing the live search bar
                setTimeout(() => {
                    setShowLiveSearchBar(true);
                }, 300); // Half of our transition time
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [currentSection, showLiveSearchBar, isTransitioning]);

    const new_hub_house_image_filename = "house-lansdcape.webp";
    // const new_hub_house_image_filename = "quoll_sample_house_no_background.png";
    const new_hub_house_image_url = CreateCloudfrontUrl(new_hub_house_image_filename);

    const getAreaClass = (id) => {
        const areaMap = {
            '2': 'roof',
            '1': 'landscaping',
            '6': 'windows',
            '10': 'hvac',
            '7': 'doors',
            '14': 'frame',
            '4': 'foundation',
            '9': 'siding',
            '5': 'plumbing',
            '13': 'basement'
        };
        return areaMap[id] || 'unknown';
    };


    // Tiny component that signals when DOM is ready
    const FlowTrigger = ({ onMount }) => {
        useEffect(() => {
            onMount();
        }, []);
        return <div style={{ display: 'none' }} />;
    };

    const sampleAddress = "4506 Dakota Ave, Nashville, TN 37209";

    return (
        <div className="dynamic-what-we-do-container">
            {/* <h1>Dynamic What We Do</h1> */}
            {/* <p>{currentSection}</p> */}
            {currentSection === 0 && (
                <>
                    {/* <div className={`dynamic-what-we-do-search-bar-wrapper ${isTransitioning ? 'transitioning' : ''}`}> */}
                    <div className={`dynamic-what-we-do-search-bar-wrapper ${deviceType}`}>

                        {deviceType === 'mobile' && (
                            <div className={`our-promises-logo-container ${deviceType}`}>
                                <div className="our-promises-quoll-animal-logo-container">
                                    <img
                                        src={quollAnimalLogo}
                                        alt="Quoll Animal Logo"
                                        id="quoll-logo-node"
                                    />
                                </div>
                            </div>
                        )}

                        <div
                            className={`dynamic-what-we-do-search-bar-display live visible`}
                        >
                            <AddressSearch locationType="regular" />
                        </div>
                        {deviceType === 'mobile' && (
                            <div className="dynamic-what-we-do-supplemental-info-frame">
                                <div
                                    className={`dynamic-what-we-do-supplemental-info-container section-${currentSection}`}
                                    id="supplemental-info-container"
                                >
                                    <span className="dynamic-what-we-do-supplemental-info-container-title text-align-center">
                                        {supplementalItem.title}
                                    </span>

                                    <span className="dynamic-what-we-do-supplemental-info-container-description text-align-center">
                                        {supplementalItem.content}
                                    </span>
                                </div>
                            </div>
                        )}
                        {/* {showLiveSearchBar && (
                            <div
                                className={`dynamic-what-we-do-search-bar-display live ${showLiveSearchBar ? 'visible' : ''}`}
                            >
                                <AddressSearch locationType="regular" />
                            </div>
                        )} */}
                        {/* {!showLiveSearchBar && (
                            <div
                                className={`dynamic-what-we-do-search-bar-display static ${isTransitioning ? 'fade-out' : ''}`}
                            >
                                <div className="search-bar-container">
                                    <div className="search-icon">🔍</div>
                                    <div className="search-text">
                                        <span className="static-text">Enter your address: </span>
                                        <span className="typing-text">{sampleAddress}</span>
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>
                </>
            )}
            {currentSection !== 0 && (
                <div className="dynamic-what-we-do-section-container">
                    {/* Risk Icons Row */}
                    {currentSection < 4 && (
                        <div className={`dynamic-what-we-do-climate-risk-icons ${deviceType}`}>
                            {filteredClimateRisks?.map(risk => {
                                const edge = edges.find(edge => edge.source === `risk-${risk.id}`);
                                // console.log('EDGE', edge);
                                return (
                                    <div className={`dynamic-what-we-do-climate-risk-item ${edge ? '' : ''}`} key={risk.id} id={`risk-${risk.id}`}>
                                        <RiskOverviewClimateIcon
                                            id={risk.id}
                                            risk_level={risk.risk_level}
                                            icon_white={risk.icon_white}
                                            icon_black={risk.icon_black}
                                            risk_name={risk.risk_name}
                                            requiresLookup={false}
                                            displayName={false}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    )}


                    <div className="house-diagram-section">
                        <div className="dynamic-what-we-do-climate-factors-home-hub-container">
                            <img
                                className="climate-factors-home-hub-image"
                                src={new_hub_house_image_url}
                                alt="House diagram"
                                id="house-diagram"
                            />
                            {currentSection < 4 && (
                                <div className={`house-risk-markers combinations-lab ${deviceType}`}>
                                    {filteredHouseAreasThreatened?.map((area) => (
                                        <div
                                            key={area.id}
                                            id={`area-${area.id}`}
                                            className={`
                                            dynamic-what-we-do-house-risk-marker
                                            dynamic-what-we-do-house-risk-marker-section-${currentSection}
                                            house-risk-marker
                                            dynamic-what-we-do-house-risk-marker-${getAreaClass(area.id)}
                                            ${deviceType} 
                                            ${area.risk_level_adjusted} 
                                            combinations-lab
                                            `}
                                        >
                                            <span>{area.category}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {/* Projects Row */}
                            {(currentSection === 3 || currentSection === 4) && (
                                <div className={`${currentSection === 3 ? 'dynamic-what-we-do-projects-row' : 'dynamic-what-we-do-projects-row-relative-container'}`}>
                                    {projectsList?.map(project => {
                                        return (
                                            <div
                                                key={project.id}
                                                className={`dynamic-what-we-do-project-item project-${project.id} ${deviceType}`}
                                                id={`project-${project.id}`}
                                            >
                                                <div className="dynamic-what-we-do-project-item-image-wrapper">
                                                    <img src={CreateCloudfrontUrl(project.project_image)} alt={project.project_name} />
                                                </div>
                                                <div className={`dynamic-what-we-do-project-item-text-wrapper ${deviceType}`}>
                                                    <span>{project.project_name}</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    </div>

                    {(currentSection > 1 || (deviceType === 'mobile')) && (
                        <div className={`dynamic-what-we-do-supplemental-info-frame ${deviceType}`}>
                            {deviceType === 'mobile' && (
                                <span className="dynamic-what-we-do-supplemental-info-container-title text-align-center">
                                    {supplementalItem.title}
                                </span>
                            )}
                            <div
                                className={`dynamic-what-we-do-supplemental-info-container section-${currentSection} ${deviceType}`}
                                id="supplemental-info-container"
                            >
                                {supplementalInfo.map(info => {

                                    if (currentSection === 2) {

                                        const description = deviceType === 'mobile' ? info.descriptionMobile : info.description;
                                        return (
                                            <div key={info.id} className={`dynamic-what-we-do-supplemental-info-item ${deviceType}`}>
                                                <div className={`how-to-think-impact-across-time-option ${deviceType}`}>
                                                    <div className="how-to-think-impact-across-time-option-timeframe-container">
                                                        <span>{info.timeframe}</span>
                                                    </div>
                                                    <div className="how-to-think-impact-across-time-option-icon-wrapper text-align-center">
                                                        <img src={CreateCloudfrontUrl(info.icon)} alt={info.title} />
                                                    </div>
                                                    <div className="how-to-think-impact-across-time-option-text-wrapper">
                                                        <span className="how-to-think-impact-across-time-option-title">{info.title}</span>
                                                        <span className="how-to-think-impact-across-time-option-description text-align-center">{description}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    } else if (currentSection === 3 || currentSection === 4) {
                                        return (
                                            <div className={`dynamic-what-we-do-supplemental-info-special-item ${deviceType}`} key={info.id}>
                                                <div className="dynamic-what-we-do-supplemental-info-special-item-icon-wrapper">
                                                    <div className="dynamic-what-we-do-supplemental-info-special-item-icon-container-background">
                                                        <img src={greenDot} alt="green dot" />
                                                    </div>
                                                    <div className="dynamic-what-we-do-supplemental-info-special-item-icon-container">
                                                        <img className="dynamic-what-we-do-supplemental-info-special-item-icon" src={CreateCloudfrontUrl(info.icon)} alt={info.title} />
                                                    </div>
                                                </div>
                                                <span className="dynamic-what-we-do-supplemental-info-special-item-name text-align-center">{info.title}</span>
                                                {currentSection === 3 && (
                                                    <div className="how-to-think-impact-across-time-option-timeframe-container">
                                                        <span>{info.timeframe}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )

                                    }
                                })}
                            </div>
                            {deviceType === 'mobile' && (
                                <span className="dynamic-what-we-do-supplemental-info-container-description text-align-center">
                                    {supplementalItem.content}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            )}
            <FlowTrigger onMount={() => setShowFlow(true)} />
            {(showFlow && flowReady && currentSection !== 0) && (

                <div className="what-if-machine-plan-summary-solving-for-container-flow-container">

                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        nodeTypes={nodeTypes}
                        fitView={false}
                        nodesDraggable={false}
                        nodesConnectable={false}
                        zoomOnScroll={false}
                        panOnScroll={false}
                        preventScrolling={true}
                        edgeTypes={edgeTypes}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'none',
                            zIndex: 1
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default DynamicWhatWeDo;

// Custom node components - just handles the positioning of the nodes
const RiskNode = () => {
    return (
        <div style={{ width: 5, height: 35, background: 'transparent' }}>
            <Handle type="source" position={Position.Bottom} style={{ visibility: 'visible' }} />
        </div>
    );
};

const ProjectNode = () => {
    return (
        <div style={{ width: 5, height: 5, background: 'transparent' }}>
            <Handle type="target" position={Position.Top} style={{ visibility: 'visible' }} />
            <Handle type="source" position={Position.Bottom} style={{ visibility: 'visible' }} />
        </div>
    );
};

const HouseImageNode = () => {
    return (
        <div style={{ width: 5, height: 5, background: 'transparent' }}>
            <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
            <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden' }} />
        </div>
    );
};


const HouseMarkerNode = () => {
    return (
        <div style={{ width: 5, height: 5, background: 'transparent' }}>
            <Handle type="target" position={Position.Top} style={{ visibility: 'visible' }} />
        </div>
    );
};

const SupplementalInfoContainerNode = () => {
    return (
        <div style={{ width: 5, height: 5, background: 'transparent' }}>
            <Handle type="target" position={Position.Top} style={{ visibility: 'visible' }} />
        </div>
    );
};
const SupplementalInfoItemNode = () => {
    return (
        <div style={{ width: 5, height: 5, background: 'transparent' }}>
            <Handle type="target" position={Position.Top} style={{ visibility: 'visible' }} />
        </div>
    );
};
